export default __webpack_public_path__ + "static/media/closet5-after2-1440w.6d9791ed.avif";